export const adminActions = {
    GET_CONFIGURATION : 'GET_CONFIGURATION',
    SAVE_CONFIGURATION: 'SAVE_CONFIGURATION'
};

const initState = {};

export const adminReducer = (state = initState, action: any) => {
    switch (action.type) {
    case adminActions.GET_CONFIGURATION:
        return  Object.assign({}, state, { configuration: action.payload });
    case adminActions.SAVE_CONFIGURATION:
        return  Object.assign({}, state, { configuration: action.payload });
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/adminReducer.ts